export default __webpack_public_path__ + "static/media/eu_funded.5270b3c2.jpg";